module.exports = __webpack_public_path__ + "static/media/InicioBloques.2d68e975.svg";